import { render, staticRenderFns } from "./ChatSettingsModal.vue?vue&type=template&id=1d25bb9e&scoped=true&"
import script from "./ChatSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ChatSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatSettingsModal.vue?vue&type=style&index=0&id=1d25bb9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d25bb9e",
  null
  
)

export default component.exports